import React from 'react';
import { ReactComponent as Computer } from 'App/assets/img/computer.svg';
import { Button } from '@welbe/design-system';
import {
	ActionButtons,
	Container,
	Description,
	Title,
} from './WithoutDoctor.styles';
import { useReferWithoutDoctor } from './WithoutDoctor.hooks';

interface WithoutDoctorProps {
	onClose: () => void;
}

export const WithoutDoctor = ({ onClose }: WithoutDoctorProps): JSX.Element => {
	const { step, handleContinue, handleDownload } = useReferWithoutDoctor();

	return (
		<Container>
			{step === 0 ? (
				<>
					<Title>Referir colaboradores</Title>
					<Computer />
					<Description>
						Al no contar con médico ocupacional, podrás referir a los
						colaboradores que lo requieran a una{' '}
						<span>institución de salud pública.</span>
					</Description>
					<Description>
						Registra a tus médicos ocupacionales para referirlos de forma
						automática.
					</Description>
					<ActionButtons>
						<Button variant="outline" width="120px" onClick={onClose}>
							Cancelar
						</Button>
						<Button
							width="120px"
							onClick={handleContinue}
							data-testid="continue"
						>
							Continuar
						</Button>
					</ActionButtons>
				</>
			) : (
				<>
					<Title>Referir colaboradores</Title>
					<Description>
						Hazle llegar a tus colaboradores la carta de derivación, documento
						que comprueba que fueron referidos.
					</Description>
					<Description>
						<span>
							Es indispensable que el colaborador regrese firmado el documento.
						</span>
					</Description>
					<ActionButtons>
						<Button variant="outline" width="120px" onClick={onClose}>
							Cancelar
						</Button>
						<Button
							width="120px"
							onClick={handleDownload}
							data-testid="download"
						>
							Descargar
						</Button>
					</ActionButtons>
				</>
			)}
		</Container>
	);
};
